import { APIS } from '@Config/apis';
import { apiDelete, apiGet, apiPost, apiPut } from '@Shared/Api/apiClient';

const ensureSector = (response, fallbackMessage) => {
  if (!response?.id || !response?.name) {
    throw new Error(response?.message || fallbackMessage);
  }

  return response;
};

const sectorService = {
  async getAll() {
    const response = await apiGet(APIS.URLS.SECTORS, true);
    if (!Array.isArray(response)) {
      throw new Error(response?.message || 'No fue posible cargar los sectores.');
    }
    return response;
  },

  async create(sector) {
    return ensureSector(
      await apiPost(APIS.URLS.SECTORS, sector, true),
      'No fue posible crear el sector.'
    );
  },

  async update(id, sector) {
    return ensureSector(
      await apiPut(`${APIS.URLS.SECTORS}/${id}`, sector, true),
      'No fue posible actualizar el sector.'
    );
  },

  async remove(id) {
    const response = await apiDelete(`${APIS.URLS.SECTORS}/${id}`, true);
    if (response?.message) {
      throw new Error(response.message);
    }
  }
};

export default sectorService;
